import React from 'react'
import { Label } from './styles'

interface InputLabelProps {
  title: string
  fontSize?: string
  color?: string
  htmlFor: string
}

export const InputLabel = ({
  title,
  fontSize,
  color,
  htmlFor,
}: InputLabelProps) => {
  return (
    <Label color={color} fontSize={fontSize} htmlFor={htmlFor}>
      {title}
    </Label>
  )
}
